export default "__VITE_ASSET__7efac52a__"